import "./fontAwesomeConfig";
import $ from 'jquery';
import "./styles/js/plugins/mobiscroll/mobiscroll.jquery.min.css";
import "./styles/js/plugins/mobiscroll/mobiscroll.jquery.min.js";
import React from 'react';
import "./styles/css/admin-style.css"
import ReactDOM from 'react-dom/client';
import "./styles/css/all.css"
import App from './App/App';
import reportWebVitals from './reportWebVitals';

//<!-- == PLUGINS == -->
// TinyMCE is self-hosted from /public/tinymce — no CSS import needed
import "@fortawesome/fontawesome-free/css/all.min.css";  // Import FontAwesome CSS


//<!-- files -->
<script type="text/javascript" src="App"></script>
window.$ = window.jQuery = $;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
